import { render } from "./CoursePanelThumbnail.vue?vue&type=template&id=39d22f6e&scoped=true"
import script from "./CoursePanelThumbnail.vue?vue&type=script&lang=js"
export * from "./CoursePanelThumbnail.vue?vue&type=script&lang=js"

import "./CoursePanelThumbnail.vue?vue&type=style&index=0&id=39d22f6e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d22f6e"]])

export default __exports__